import { getUrlName } from 'chairisher/context/site';

/**
 * Maps Chairish page URL names to Bing UET ecomm_pagetype values.
 *
 * @see https://learn.microsoft.com/en-us/advertising/guides/uet-conversion-api-integration?view=bingads-13
 */
const URL_NAME_TO_BING_ECOMM_PAGE_TYPE = {
    account_query_term_search: 'searchresults',
    cart_list: 'cart',
    collection_query_term_search: 'category',
    collection_search: 'category',
    home_index: 'home',
    product_detail: 'product',
    product_detail_no_slug: 'product',
    product_list: 'searchresults',
};

/**
 * Maps the current page URL name to a Bing UET ecommerce page type.
 *
 * @returns {string}
 */
export function getBingEcommPageType() {
    return URL_NAME_TO_BING_ECOMM_PAGE_TYPE[getUrlName()] ?? 'other';
}
